import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/components/App';
import { GatewayShell } from '@/components/GatewayShell';
import { shouldRenderGatewayShell } from '@/utils/gatewayShell';
import { ErrorBoundary } from '@sentry/react';
import { StateMessage } from '@matrix-forge/ui/custom/StateMessage';
import { registerPreloadErrorReload } from '@/utils/preloadErrorReload';
import './index.css';

// Recover stale tabs after a deploy by reloading when a lazy chunk 404s.
registerPreloadErrorReload();

// Initialize test helpers for Playwright E2E tests (dev/test mode only)
if (import.meta.env.DEV || import.meta.env.MODE === 'test') {
  import('./testHelpers').then(({ initializeTestHelpers }) => {
    initializeTestHelpers();
  });
}

const rootNode = document.getElementById('root');
if (rootNode) {
  // Behind the separable gateway (and only at the top window) render the
  // GatewayShell — a rail + same-origin iframe pane. In every other context
  // (direct :4000, Vite :5173, direct :443, production ingress, or inside the
  // shell's iframe) this is false and the app renders exactly as it does today.
  const renderGatewayShell = shouldRenderGatewayShell();
  createRoot(rootNode).render(
    <StrictMode>
      <ErrorBoundary
        fallback={
          <StateMessage
            isAbsolute
            isError
            title="Something went wrong."
            description="Please reload the page to try again."
          />
        }
      >
        {renderGatewayShell ? <GatewayShell /> : <App />}
      </ErrorBoundary>
    </StrictMode>
  );
} else {
  console.error('Studio: could not mount; "root" node not found.');
}
